import {RenderingServices} from '@wallaby-ui/core';
import {ICellRendererParams} from 'ag-grid-community';

import {eventAnnotationTypeRenderer} from './event_annotation_type_renderer';

/**
 * Returns raw Html version of TimelineAnnotationTypeFormatter component.
 * @param params
 * @param services
 * @returns {String}
 */
export function timelineAnnotationTypeFormatter(
  params: ICellRendererParams,
  services: RenderingServices = {}
) {
  const {value} = params;
  return value
    ? `<div>
            ${
              value &&
              value.annotations &&
              value.annotations
                .map((annotation) =>
                  eventAnnotationTypeRenderer({annotation}, services)
                )
                .join('')
            }
        </div>`
    : '';
}
